import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

import { computed, watchEffect, ref, useAttrs, watch } from 'vue'
import { useVModel } from '@vueuse/core'
import CosSelectView from '../CosView/select.vue'
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: [String, Number, Array]
  },
  validKey: {
    type: [String, Number, Array]
  },
  autoLanguage: {
    type: Boolean,
    default: true
  },
  placeholder: {
    type: String
  },
  trim: {
    type: Boolean, // 去掉前后空格
    default: true
  },
  view: {
    type: Boolean
  },
  disabled: {
    type: Boolean,
    default: false
  },
  allowClear: {
    type: Boolean,
    default: true
  },
  clearVal: {
    type: [String, Number, Array]
  },
  filterNoVal: {
    type: Boolean, // 是否清除0 null-》 '' 只处理字符串
    default: false
  },
  options: {
    type: Array
  },
  fieldNames: {
    type: Object
  }
},
  emits: ['update:value', 'update:validKey', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const attrs = useAttrs()
const props = __props
const disabledComputed = computed(() => {
  return props.view ? true : props.disabled
})
const optionComputed = computed(() => {
  if (!props.autoLanguage) {
    return props.options
  }
  if (props.options) {
    const label = props.fieldNames?.label || 'label'
    props.options?.forEach((item: any) => {
      if (item.lang) {
        item[label] = t(item.lang)
      }
    })
  }
  return props.options
})
const emit = __emit
const vaildValue = useVModel(props, 'validKey', emit)
const modelValue = ref()
const viewOption = computed(() => {
  const viewOptions: any = attrs.viewOptions
  const { mode } = attrs
  let result: any
  const fieldNames: any = attrs.viewFieldNames
  const valKey = fieldNames && fieldNames.value ? fieldNames.value : 'value'
  const obj: any = {}
  if (mode === 'multiple') {
    result = []
    if (props.value && Array.isArray(props.value)) {
      props.value.forEach((item) => {
        const findv = viewOptions?.find((v: any) => v[valKey] === item)
        obj[valKey] = item
        result.push(findv || obj)
      })
    }
    return result || []
  } else {
    const findv = viewOptions?.find((item: any) => item[valKey] === props.value)
    obj[valKey] = props.value
    result = findv || obj
    return result
  }
})

const change = (v: any) => {
  let result = v
  if (attrs.mode !== 'multiple') {
    if (v === undefined) {
      const options: any = attrs.options
      if (options && options.length) {
        // init 类型就是-9 string ''  只处理带有options
        const vkey = (props.fieldNames && (props.fieldNames as any).value) || 'value'
        if (typeof options[0][vkey] === 'string') {
          result = ''
        } else {
          result = -9
        }
      } else if (typeof props.value === 'number') {
        result = -9
      }
      if (props.clearVal !== undefined) {
        result = props.clearVal
      }
    }
  }
  if (result === -9) {
    vaildValue.value = undefined
  } else {
    vaildValue.value = result
  }
  emit('update:value', result)
  emit('change', result)
}
watch(
  () => props.value,
  (v) => {
    if (v !== -9 && v !== '') {
      modelValue.value = v
      vaildValue.value = v
      if (attrs.mode === 'multiple') {
        // 多选去掉null
        if (v === null) {
          modelValue.value = []
        }
      }
    } else {
      modelValue.value = undefined
      vaildValue.value = undefined
    }
  },
  { immediate: true }
)
watchEffect(() => {
  if (props.filterNoVal && (modelValue.value === 0 || modelValue.value === '' || modelValue.value === null)) {
    modelValue.value = undefined
  }
})

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (__props.view && (__props.options || _ctx.$attrs.viewOptions))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (__props.options)
          ? (_openBlock(), _createBlock(CosSelectView, _mergeProps({ key: 0 }, _ctx.$attrs, {
              options: optionComputed.value,
              fieldNames: __props.fieldNames,
              value: modelValue.value
            }), null, 16, ["options", "fieldNames", "value"]))
          : _createCommentVNode("", true),
        (_ctx.$attrs.viewOptions)
          ? _renderSlot(_ctx.$slots, "view", {
              key: 1,
              option: viewOption.value
            })
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock(_component_a_select, _mergeProps({ key: 1 }, _ctx.$attrs, {
        value: modelValue.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
        onChange: change,
        style: {"width":"100%"},
        allowClear: __props.allowClear,
        disabled: disabledComputed.value,
        fieldNames: __props.fieldNames,
        placeholder: __props.placeholder || _ctx.$t('common.pleaseSelect'),
        class: { 'form-item-disabled-view': __props.view },
        options: optionComputed.value
      }), _createSlots({ _: 2 }, [
        _renderList(_ctx.$slots, (_, name) => {
          return {
            name: name,
            fn: _withCtx((slotData) => [
              _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData || {})))
            ])
          }
        })
      ]), 1040, ["value", "allowClear", "disabled", "fieldNames", "placeholder", "class", "options"]))
}
}

})